import Vue from 'vue'
import VueCookie from 'vue-cookie'
Vue.use(VueCookie)

export default {

  getCookie: function () {
   return Vue.cookie.get('token')
  },
  resetCookie: function () {
    Vue.cookie.delete('token')
  },
  setCookie: function (token) {
    Vue.cookie.set('token',token,{ expires: '5D' })
  }
}
